module.exports = __webpack_public_path__ + "img/clothing160.cfbf8f02.jpg";